// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__v2Q1J","inner":"Footer_inner__O53Zv","nextIcon":"Footer_nextIcon__27foZ","innerLeft":"Footer_innerLeft__1TsRJ"};